/** Shared admin sidebar / mobile strip links (dashboard + settings). */
export const ADMIN_NAV_LINKS = [
  {
    label: 'Dashboard',
    to: '/dashboard',
    icon: 'dashboard',
    isActive: (pathname, hash) =>
      pathname === '/dashboard' &&
      hash !== '#services' &&
      hash !== '#gallery' &&
      hash !== '#products',
  },
  {
    label: 'Services',
    to: '/dashboard#services',
    icon: 'design_services',
    isActive: (pathname, hash) => pathname === '/dashboard' && hash === '#services',
  },
  {
    label: 'Gallery',
    to: '/dashboard#gallery',
    icon: 'collections',
    isActive: (pathname, hash) => pathname === '/dashboard' && hash === '#gallery',
  },
  {
    label: 'Products',
    to: '/dashboard#products',
    icon: 'chair',
    isActive: (pathname, hash) => pathname === '/dashboard' && hash === '#products',
  },
  {
    label: 'Settings',
    to: '/admin/settings',
    icon: 'settings',
    isActive: (pathname) => pathname.startsWith('/admin/settings'),
  },
];
